import axios from 'axios';

const state = {
    token: localStorage.getItem('user-token') || '',
    id: '',
    first: '',
    last: '',
    slug: '',
    permissions: [],
    groups: [],
    sections: [],
    menu: [],
    nimdarepus: false,
    emailProvider: null
};

// define the possible mutations that can be applied to our state
const mutations = {
    AUTH_SUCCESS: (state, payload) => {
        if (payload.token){
            state.token = payload.token;
        }

        state.id = payload.user.id;
        state.first = payload.user.first;
        state.last = payload.user.last;
        state.slug = payload.user.slug;
        state.permissions = payload.user.permissions.map(permission => {
            return permission.route
        });
        state.groups = payload.user.groups;
        state.menu = payload.user.menu;
        state.sections = payload.user.sections.map(section => {
            return section.route;
        });
        state.nimdarepus = payload.user.nimdarepus;
        state.emailProvider = payload.user.email_provider;
        state.mobile = payload.user.mobile;
        state.position = payload.user.position;
    },
    AUTH_RELOAD: (state, payload) => {
        if (payload.token){
            state.token = payload.token;
        }

        state.id = payload.id;
        state.first = payload.first;
        state.last = payload.last;
        state.slug = payload.slug;
        state.permissions = payload.permissions.map(permission => {
            return permission.route
        });
        state.groups = payload.groups;
        state.menu = payload.menu;
        state.sections = payload.sections.map(section => {
            return section.route;
        });
        state.nimdarepus = payload.nimdarepus;
        state.emailProvider = payload.email_provider;
        state.mobile = payload.mobile;
        state.position = payload.position;
    },
    CLEAR_SESSION: (state) => {
        state.token = '';
        state.id = '';
        state.first = '';
        state.last = '';
        state.slug = '';
        state.permissions = [];
        state.groups = [];
        state.sections = [];
        state.menu = [];
        state.nimdarepus = null;
        state.emailProvider = null;
    }
};

const getters = {
    token: state => {
        return state.token;
    },
    fullName: state => {
        return state.first+' '+state.last;
    },
    permissions: state => {
        return state.permissions;
    },
    groups: state => {
        return state.groups;
    },
    sections: state => {
        return state.sections;
    },
    menu: state => {
        return state.menu;
    },
    nimdarepus: state => {
        return state.nimdarepus;
    },
    emailProvider: state => {
        return state.emailProvider;
    }
}

const actions = {
    AUTH_CONFIRM: ({commit, state, dispatch}) => {
        if (state.token){
            return new Promise((resolve) => {
                axios.get(process.env.VUE_APP_API_URL + '/me').then(response => {
                    commit('AUTH_RELOAD', response.data);
                    dispatch('INIT_DATA');
                })
                .catch(error => {
                    commit('CLEAR_SESSION');
                    commit('CLEAR_CACHE');
                    resolve(error);
                });
            });
        }
    },
    AUTH_REQUEST: ({commit}, user) => {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
                axios.post(process.env.VUE_APP_API_URL + '/authenticate', user).then(response => {
                axios.defaults.headers.common['Authorization'] = 'Bearer '+ response.data.token;
                commit('AUTH_SUCCESS', response.data);
                resolve(response);
            })
            .catch(error => {
                commit('CLEAR_SESSION');
                commit('CLEAR_CACHE');
                reject(error);
            });
        })
    },
    AUTH_LOGOUT: ({commit}) => {
        return new Promise((resolve) => {
            commit('CLEAR_SESSION');
            commit('CLEAR_CACHE');
            delete axios.defaults.headers.common['Authorization']
            resolve();
        })
    }
}

const module = {
    state,
    mutations,
    getters,
    actions
};

export default module;
